import { headerHeight } from "@/components/fragments/header/const";

export const plansDetailShipmentIdTestId = "pages/plans/detail/[shipmentId]";
export const skeletonTestId = "pages/plans/detail/[shipmentId]-skeleton";
export const contentTestId = "pages/plans/detail/[shipmentId]-content";
export const planInfoTestId = "pages/plans/detail/[shipmentId]-planinfo";

export const topId = "top";

export const scrollOffset = -parseInt(headerHeight, 10);
